import React from "react";
import cx from "classnames";
import styles from "./Toggle.module.scss";
import IBaseFormComponentProps from "../../../interfaces/IBaseFormComponentProps";
import InputWrapper from "../InputWrapper/InputWrapper";

interface IToggle
    extends Omit<
        IBaseFormComponentProps<HTMLInputElement, string>,
        "value" | "onChange"
    > {
    options: IToggleOption[];
    onChange: (id: string) => void;
}

interface IToggleOption {
    id: string;
    label: string;
    selected?: boolean;
}

const Toggle: React.FC<IToggle> = (props) => {
    const {
        label,
        name,
        children,
        hasError,
        isDisabled,
        className,
        tooltipContent
    } = props;
    return (
        <InputWrapper
            label={label}
            className={cx(styles["toggle-container"], {
                [styles["toggle-container--invalid"]]: hasError,
                [className]: !!className
            })}
            hasError={hasError}
            tooltipContent={tooltipContent}>
            <div className={cx(styles["toggle"], "layout-flex-s")}>
                {props.options.map((i) => (
                    <label
                        className={cx(styles["toggle-option"], {
                            [styles["toggle-option--selected"]]: i.selected
                        })}
                        key={`${name}-${i.id}`}>
                        <input
                            type="radio"
                            name={name}
                            checked={i.selected}
                            value={i.label}
                            onChange={() => !isDisabled && props.onChange(i.id)}
                        />
                        {i.label}
                    </label>
                ))}
            </div>
            {children}
        </InputWrapper>
    );
};

export default Toggle;
